<template>
  <div class="login_body">
    <div class="login_top">
        <img src="../../assets/banner.png" alt="" style="width:160px;vertical-align: middle">
    </div>
    <div class="login_main">        
        <van-cell-group>
            <van-field    v-model="username"    required    clearable    label="用户名"    placeholder="请输入用户名"  />  
            <van-field    v-model="password"    type="password"    label="密码"    placeholder="请输入密码"    required  />
        </van-cell-group>
        <van-button type="info" class='loginBtn' :loading='loginLoading' block @click="handleSubmit">登录</van-button>


<!-- 
            <x-input class="userInp" title="用户名" :show-clear='false'  v-model="username">
                <div slot="label" class="name__icon">
                    <img src="@/assets/user.png"  alt="">
                </div>
            </x-input>        
        
            <x-input class="userInp" title="密码" type='password' :show-clear='false'  v-model="password">
                <div slot="label" class="name__icon">
                    <img src="@/assets/pwd.png"  alt="">
                </div>
            </x-input>

            <x-button class='loginBtn' type='primary' @click.native="handleSubmit" text="登录"></x-button>
         -->
    </div>
        
  </div>
</template>

<script>
import { mapActions,mapState } from 'vuex'
import { setToken } from '@/request/user'
export default {
  name: 'login',
  components: {
   
  },
  data () {
    return {
        username:'',
        password:'',
        loginLoading:false,
    }
  },
  computed: {
    ...mapState(['logCode'])
  },
  methods: {
    ...mapActions([
      'handleLogin',
      'getUserInfo'
    ]),
    handleSubmit () {
        this.loginLoading = true
        let userName = this.username
        let password = this.password
      this.handleLogin({ userName, password }).then(res => {
        this.loginLoading = false
        if (this.logCode == '1001') {
          setToken('')
        }else{
          this.getUserInfo().then(res => {
             let redirect = this.$route.query.redirect
             if (redirect) {
               this.$router.push(redirect)
             }else{
                this.$router.push({
                  name: 'home'
                })
             }
          })
        }
      })
    }
  },
}
</script>

<style scoped>
.login_top{background:#199bd6;min-height: 35%;line-height: 35%;padding-bottom: 10px;text-align:center}
.login_top img{transform: translateY(100%);}
.login_body{background:#efeff4;height:100%}
/* .login_main{padding-top:50px} */
.userInp{width:65%;margin:auto;border-radius:5px;border: 1px solid #C8C7CC;height: 25px;margin-top:20px;background:#fff}
.name__icon img{width:25px;padding-right:10px;margin-left: -5px;}
.loginBtn{margin:auto;width:90%;margin-top:40px}

</style>
